import React from 'react'

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  color?: 'primary' | 'secondary' | 'white'
  text?: string
  fullScreen?: boolean
}

export function LoadingSpinner({
  size = 'md',
  color = 'primary',
  text,
  fullScreen = false,
}: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'w-9 h-9',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
  }

  const colorClasses = {
    primary: 'text-primary-500',
    secondary: 'text-secondary-500',
    white: 'text-white',
  }

  const textColorClasses = {
    primary: 'text-[var(--color-text-secondary)]',
    secondary: 'text-[var(--color-text-secondary)]',
    white: 'text-white',
  }

  const spinner = (
    <div className="flex flex-col items-center justify-center space-y-4">
      <div className={`premium-spinner ${sizeClasses[size]} ${colorClasses[color]}`}>
        <span className="premium-spinner__ring" />
        <span className="premium-spinner__pulse" />
        <span className="premium-spinner__meteor" />
      </div>
      {text && <p className={`text-sm font-medium ${textColorClasses[color]}`}>{text}</p>}
    </div>
  )

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-[var(--color-bg)]/95 backdrop-blur-sm flex items-center justify-center z-50">
        {spinner}
      </div>
    )
  }

  return spinner
}
